import {
  LIST_TRANSACTION_DATA_CASHIER_REQUEST,
  LIST_TRANSACTION_DATA_CASHIER_SUCCESS,
  LIST_TRANSACTION_DATA_CASHIER_FAIL,
  LIST_TRANSACTION_DATA_ADMISSION_REQUEST,
  LIST_TRANSACTION_DATA_ADMISSION_SUCCESS,
  LIST_TRANSACTION_DATA_ADMISSION_FAIL,
  LIST_TRANSACTION_DATA_PHOTO_PATIENT_REQUEST,
  LIST_TRANSACTION_DATA_PHOTO_PATIENT_SUCCESS,
  LIST_TRANSACTION_DATA_PHOTO_PATIENT_FAIL,
  LIST_TRANSACTION_DATA_REQUEST,
  LIST_TRANSACTION_DATA_SUCCESS,
  LIST_TRANSACTION_DATA_FAIL,
  RE_SYNC_TRANSACTION_DATA_FAILED_REQUEST,
  RE_SYNC_TRANSACTION_DATA_FAILED_SUCCESS,
  RE_SYNC_TRANSACTION_DATA_FAILED_FAIL,
  SYNC_DATA_TRANSACTION_DATA_REQUEST,
  SYNC_DATA_TRANSACTION_DATA_SUCCESS,
  SYNC_DATA_TRANSACTION_DATA_FAIL
} from '../../../constants/synchronize-data/transaction-data'

const initialState = {
  loading: false,
  loadingSync: false,
  loadingReSync: false,
  cashierData: [],
  admissionData: [],
  photoPatientData: [],
  error: null,
  transactionData: [],
  pageable: {
    page: 1,
    size: 10
  }
}

const transactionData = (state = initialState, action) => {
  switch (action.type) {
    case LIST_TRANSACTION_DATA_CASHIER_REQUEST:
      return { ...state, loading: true }
    case LIST_TRANSACTION_DATA_CASHIER_SUCCESS:
      return {
        ...state,
        loading: false,
        cashierData: action.payload,
        pageable: action.pageable
      }
    case LIST_TRANSACTION_DATA_CASHIER_FAIL:
      return {
        ...state,
        loading: false,
        cashierData: [],
        error: action.payload
      }
    case LIST_TRANSACTION_DATA_ADMISSION_REQUEST:
      return { ...state, loading: true }
    case LIST_TRANSACTION_DATA_ADMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        admissionData: action.payload,
        pageable: action.pageable
      }
    case LIST_TRANSACTION_DATA_ADMISSION_FAIL:
      return {
        ...state,
        loading: false,
        admissionData: [],
        error: action.payload
      }
    case LIST_TRANSACTION_DATA_PHOTO_PATIENT_REQUEST:
      return { ...state, loading: true }
    case LIST_TRANSACTION_DATA_PHOTO_PATIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        photoPatientData: action.payload,
        pageable: action.pageable
      }
    case LIST_TRANSACTION_DATA_PHOTO_PATIENT_FAIL:
      return {
        ...state,
        loading: false,
        photoPatientData: [],
        error: action.payload
      }
    case LIST_TRANSACTION_DATA_REQUEST:
      return { ...state, loading: true }
    case LIST_TRANSACTION_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        transactionData: action.payload,
        pageable: action.pageable
      }
    case LIST_TRANSACTION_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        transactionData: action?.dummy
      }
    case RE_SYNC_TRANSACTION_DATA_FAILED_REQUEST:
      return { ...state, loadingReSync: true }
    case RE_SYNC_TRANSACTION_DATA_FAILED_SUCCESS:
      return {
        ...state,
        loadingReSync: false
      }
    case RE_SYNC_TRANSACTION_DATA_FAILED_FAIL:
      return {
        ...state,
        loadingReSync: false,
        error: action.payload
      }
    case SYNC_DATA_TRANSACTION_DATA_REQUEST:
      return { ...state, loadingSync: true }
    case SYNC_DATA_TRANSACTION_DATA_SUCCESS:
      return {
        ...state,
        loadingSync: false
      }
    case SYNC_DATA_TRANSACTION_DATA_FAIL:
      return {
        ...state,
        loadingSync: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default transactionData
